import { createAsyncThunk, createSlice, isAnyOf, PayloadAction } from "@reduxjs/toolkit";
import { ProductTypeResponse, ProjectDetails, ProjectData, ProjectCount } from "../../models/CreateNewProject";
import { RootState } from "../store";
import { ProjectApi } from "../../shared/api/ProjectApi";

export interface ProjectState {
    projects: ProjectData[];
    loading: boolean;
    error: string | null;
    // productTypeData: any | null;
    activeProductTypeId: number[] | null; 
    activeProjectStatus: string[] | null;
    projectStatus: string[] | null;
    formData: any | null; 
    hasNext: boolean;
    hasPrevious: boolean;
    statusCount : ProjectCount

};

const initialState: ProjectState = {
    projects: [],
    loading: false,
    error: null,
    // productTypeData: null as ProductTypeResponse | null,
    activeProductTypeId: null, 
    activeProjectStatus: null,
    projectStatus: null,
    formData: null,
    hasNext: false,
    hasPrevious: false,
    statusCount :{}
};


export const projectSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        setActiveProductTypeId(state, action: PayloadAction<number[] | null>) {
            state.activeProductTypeId = action.payload;  // Update activeProductTypeId
        },
        setActiveProjectStatus(state, action: PayloadAction<string[] | null>) {
            state.activeProjectStatus = action.payload;
        },
        setProjectStatus(state, action: PayloadAction<string[] | null>) {
            state.projectStatus = action.payload;
        },
        setAllProjectsData(state, action: PayloadAction<any[]>) {
          state.projects = action.payload;
          // const newProjects = action.payload.filter(
          //   (newProject) => !state.projects.some((existingProject) => existingProject.id === newProject.id)
          // );
          // state.projects = [...state.projects, ...newProjects];
        },
        setProjectDataForChange(state, action: PayloadAction<any[]>) {
          const newProjects = action.payload.filter(
            (newProject) => !state.projects.some((existingProject) => existingProject.id === newProject.id)
          );
          state.projects = [...state.projects, ...newProjects];
        }
    },
    extraReducers: (builder) => {
        // builder.addMatcher(
        //     isAnyOf(
        //         ProjectApi.endpoints.getProjectData.matchFulfilled,
        //     ),
        //     (state, action) => {
        //         state.loading = false;
        //         if (action.payload && action.payload) {
        //             state.projects = action.payload.Projects
        //         }
        //         console.log(state.projects, "projects");
        //     }
        // );

        // builder.addMatcher(
        //     isAnyOf(
        //         ProjectApi.endpoints.getProjectData.matchPending,
        //     ),
        //     (state) => {
        //         state.loading = true;
        //         state.error = ""; 
        //     } 
        // );

        // builder.addMatcher(
        //     isAnyOf(
        //         ProjectApi.endpoints.getProjectData.matchRejected,
        //     ),
        //     (state, action) => {
        //         state.loading = false;
        //         state.error = action.error?.message || "Failed to fetch or create project";
        //     }
        // );

        // builder.addMatcher(
        //     isAnyOf(
        //         ProjectApi.endpoints.getAllProjectData.matchFulfilled,
        //     ),
        //     (state, action) => {
              
        //         state.loading = false;
        //         state.projects = action.payload.Projects;
        //         state.hasNext = action.payload.hasNext;
        //         state.hasPrevious = action.payload.hasPrevious;
        //         console.log(state.projects, "projects");
        //     }
        // );

        // builder.addMatcher(
        //     isAnyOf(
        //         ProjectApi.endpoints.getAllProjectData.matchPending,
        //     ),
        //     (state) => {
        //         state.loading = true;
        //         state.error = null;
        //     }
        // );
        
        // builder.addMatcher(
        //     isAnyOf(
        //         ProjectApi.endpoints.getAllProjectData.matchRejected,
        //     ),
        //     (state, action) => {
        //         state.loading = false;
        //         state.error = action.error.message || 'Fialed to fetch product type data';
        //     }
        // );

        builder.addMatcher(
            isAnyOf(ProjectApi.endpoints.getFormData.matchFulfilled),
            (state, action) => {
              state.loading = false;
              // Assuming the API response has a field `formData` or adjust accordingly
              state.formData  = action.payload; // Save the FormData in productTypeData or adjust state key
            }
          );
      
          builder.addMatcher(
            isAnyOf(ProjectApi.endpoints.getFormData.matchPending),
            (state) => {
              state.loading = true;
              state.error = null;
            }
          );
      
          builder.addMatcher(
            isAnyOf(ProjectApi.endpoints.getFormData.matchRejected),
            (state, action) => {
              state.loading = false;
              state.error = action.error.message || "Failed to fetch form data";
            }
          );

          // builder.addMatcher(
          //   isAnyOf(ProjectApi.endpoints.getProjectStatusCount.matchFulfilled),
          //   (state, action) => {
          //     state.loading = false;
          //     // Assuming the API response has a field `formData` or adjust accordingly
          //     state.statusCount  = action.payload; // Save the FormData in productTypeData or adjust state key
          //   }
          // );
      
          // builder.addMatcher(
          //   isAnyOf(ProjectApi.endpoints.getProjectStatusCount.matchPending),
          //   (state) => {
          //     state.loading = true;
          //     state.error = null;
          //   }
          // );
      
          // builder.addMatcher(
          //   isAnyOf(ProjectApi.endpoints.getProjectStatusCount.matchRejected),
          //   (state, action) => {
          //     state.loading = false;
          //     state.error = action.error.message || "Failed to fetch form data";
          //   }
          // );

    }             
})

// export const selectProjectData = (state: any) =>  state.project.projects;
export const selectProjectLoading = (state: any) => state.project.loading;
export const selectProjectError = (state: any) => state.project.error;
export const selectProductTypeData = (state: any) => state.project.projects;
export const selectActiveProductTypeIds = (state: any) => state.project.activeProductTypeIds; 
export const { setActiveProductTypeId, setActiveProjectStatus, setProjectStatus, setAllProjectsData, setProjectDataForChange } = projectSlice.actions;
export const selectFormData = (state: RootState) => state.project.formData ;
export const selectHasNext = (state: RootState) => state.project.hasNext;
export const selectHasPrevious = (state: RootState) => state.project.hasPrevious;
export const selectProjectStatusCount = (state: RootState) => state.project.statusCount;


